import React from 'react';
import PropType from 'prop-types';
import FormationsPage from './formationPage';
import {HrLine} from 'ui';
import {MainTitleDark, Container, Button} from './styles';
import {withState} from 'recompose';

const FormationsList = ({pages, setPages, endReached, setEndReached}) => {
  const onEndReached = () => {
    setEndReached(true);
    setPages(pages - 1);
  };
  const formationsPages = [];
  for (let page = 1; page <= pages; page++) {
    formationsPages.push(<FormationsPage onEndReached={onEndReached} key={page} page={page} />);
  }
  return (
    <Container>
      <MainTitleDark>Les formations</MainTitleDark>
      <HrLine />
      {formationsPages.map(page => page)}
      {!endReached && <Button onClick={() => setPages(pages + 1)}>Voir plus de formations</Button>}
    </Container>
  );
};

FormationsList.propTypes = {
  pages: PropType.number.isRequired,
  setPages: PropType.func.isRequired,
  endReached: PropType.bool.isRequired,
  setEndReached: PropType.func.isRequired,
};

export default FormationsList
  |> withState('pages', 'setPages', 1)
  |> withState('endReached', 'setEndReached', false);
